import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Eye, CheckCircle2, ShieldCheck, Award, ArrowRight, Download } from 'lucide-react';
import { Button } from '../components/ui/button';
import Reveal from '../components/Reveal';
import Counter from '../components/Counter';
import { PageHero } from './Products';
import { ABOUT, STATS, HERO_IMAGES, COMPANY } from '../mock';

export default function About() {
  return (
    <div className="bg-[#070a12]">
      <PageHero title="About Us" crumb="About" image={HERO_IMAGES[1]} />

      <section className="py-28">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
          <Reveal className="img-zoom rounded-3xl overflow-hidden grad-border">
            <img src={HERO_IMAGES[0]} alt="We are Closefire" className="w-full h-[500px] object-cover" />
          </Reveal>
          <Reveal delay={120}>
            <div className="section-eyebrow fire-text">Who We Are</div>
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl mt-4 text-white">We Are Closefire</h2>
            <p className="text-gray-400 text-lg leading-relaxed mt-5">{ABOUT.intro}</p>
            <p className="text-gray-400 text-lg leading-relaxed mt-4">{ABOUT.intro2}</p>
            <a href={COMPANY.brochureUrl} target="_blank" rel="noopener noreferrer" className="mt-7 inline-flex items-center gap-2 font-heading font-semibold text-white hover:text-primary transition-colors"><Download className="w-4 h-4" /> Download Refilling Brochure</a>
          </Reveal>
        </div>
      </section>

      <section className="py-24 bg-[#05070d]">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-8">
          <Reveal>
            <div className="glass rounded-3xl p-9 h-full">
              <span className="grid place-items-center w-14 h-14 rounded-2xl bg-gradient-to-br from-primary to-accent text-white mb-6"><Eye className="w-7 h-7" /></span>
              <h3 className="font-heading font-extrabold text-3xl text-white">Our Vision</h3>
              <p className="text-gray-400 text-lg mt-4 leading-relaxed">{ABOUT.vision}</p>
            </div>
          </Reveal>
          <Reveal delay={120}>
            <div className="glass rounded-3xl p-9 h-full">
              <span className="grid place-items-center w-14 h-14 rounded-2xl bg-white/10 text-white mb-6"><Target className="w-7 h-7" /></span>
              <h3 className="font-heading font-extrabold text-3xl text-white">Our Mission</h3>
              <ul className="mt-5 space-y-3">
                {ABOUT.mission.map((m, i) => <li key={i} className="flex gap-3"><CheckCircle2 className="w-5 h-5 text-primary shrink-0 mt-0.5" /><span className="text-gray-300">{m}</span></li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-28">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal className="text-center max-w-2xl mx-auto mb-14">
            <div className="section-eyebrow fire-text justify-center"><Award className="w-4 h-4 text-primary" /> Operational Expertise</div>
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl mt-4 text-white">Our Core Areas of Operation</h2>
          </Reveal>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {ABOUT.coreAreas.map((c, i) => (
              <Reveal key={i} delay={(i % 3) * 90}>
                <div className="flex gap-4 p-6 rounded-3xl glass glass-hover h-full"><ShieldCheck className="w-6 h-6 text-primary shrink-0" /><p className="text-gray-200 font-medium">{c}</p></div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#05070d]">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 100} className="text-center">
              <div className="font-display font-extrabold text-5xl md:text-6xl fire-text"><Counter to={s.value} suffix={s.suffix} /></div>
              <div className="text-gray-400 font-heading font-semibold mt-2 uppercase tracking-wide text-sm">{s.label}</div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="relative py-24 overflow-hidden">
        <img src={HERO_IMAGES[2]} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#070a12]/85" />
        <Reveal className="relative max-w-3xl mx-auto px-6 text-center">
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-white">Ready to Make Your Premises Safe?</h2>
          <Button asChild size="lg" className="mt-8 gap-2 bg-gradient-to-r from-primary to-accent"><Link to="/contact">Get In Touch <ArrowRight className="w-4 h-4" /></Link></Button>
        </Reveal>
      </section>
    </div>
  );
}
